import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loader", "LoadingComponent"];
import LoadingScreen from 'pricing-pages-ui-components/components/LoadingScreen';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
function makeLoadable(_ref) {
  let {
      loader,
      LoadingComponent
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return Loadable(Object.assign({
    loader,
    LoadingComponent
  }, rest));
}
export const PublicMarketingHubPage = makeLoadable({
  loader: () => import( /* webpackChunkName: "public-marketing-hub-page" */'./marketing/PublicMarketingHubPage'),
  LoadingComponent: LoadingScreen
});